import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import '../../../../css/_decisionOverlay.scss';
import { useTranslation } from 'react-i18next';
import { FlexDiv } from '../../../design-system/containers';
import { rgba } from 'polished';
import { palette } from '../../../design-system/colors';
import { Heading2 } from '../../../design-system/headings';
import { TextDefault } from '../../../design-system/texts';

const DecisionChoice = styled(FlexDiv).attrs({
    as: 'button',
    type: 'button',
})`
    border: none;
    font: inherit;
    cursor: pointer;
    &:focus {
        outline: none;
    }
    &:focus-visible {
        outline: 2px solid ${palette.evergreen.aspargus};
        outline-offset: 2px;
    }
`;

export const DecisionOverlay = observer(
    ({ decisionQuestion, onAnswer, isAtEnd }) => {
        const { t } = useTranslation();

        const madeDecision = (decision) => {
            onAnswer(decisionQuestion.id, decision);
        };

        useEffect(() => {}, [decisionQuestion]);

        return (
            <FlexDiv
                positionAbsolute
                zIndex={2}
                justifyCenter
                alignCenter
                fullWidth
                fullHeight
                column
                backgroundColor={rgba(0, 0, 0, 0.4)}
            >
                <FlexDiv
                    dropShadowBelow
                    borderRadius={3}
                    positionRelative
                    py={24}
                    px={48}
                >
                    <Heading2
                        noTranslate
                        color={palette.graphite.white}
                        center
                    >
                        {isAtEnd
                            ? t('The end')
                            : t(decisionQuestion.questionText)}
                    </Heading2>
                </FlexDiv>
                {!isAtEnd && (
                    <FlexDiv
                        desktopOnly
                        gap={16}
                        role="group"
                        aria-label={t(decisionQuestion.questionText)}
                    >
                        <DecisionChoice
                            onClick={() =>
                                madeDecision(decisionQuestion.decision_1)
                            }
                            width={240}
                            justifyCenter
                            alignCenter
                            backgroundColor={palette.graphite.white}
                            borderRadius={4}
                            textAlignCenter
                        >
                            <TextDefault my={16} bold>
                                {t(decisionQuestion.decision_1.text)}
                            </TextDefault>
                        </DecisionChoice>
                        <DecisionChoice
                            onClick={() =>
                                madeDecision(decisionQuestion.decision_2)
                            }
                            width={240}
                            justifyCenter
                            alignCenter
                            backgroundColor={palette.graphite.white}
                            borderRadius={4}
                            textAlignCenter
                        >
                            <TextDefault my={16} bold>
                                {t(decisionQuestion.decision_2.text)}
                            </TextDefault>
                        </DecisionChoice>
                    </FlexDiv>
                )}
            </FlexDiv>
        );
    }
);
